import { motion } from "framer-motion";
import { Mail, Send } from "lucide-react";
import { fadeUp, EASE, VIEWPORT_80 } from "@/lib/animations";
import { Section, Overline, H2 } from "./JobPrimitives";
import { ApplicationForm } from "./ApplicationForm";
import { MAILTO_SIMPLE, APPLY_EMAIL } from "./jobData";

const ctaReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT_80,
  transition: { duration: 0.7, ease: EASE },
};

export const JobCandidatura = () => (
  <Section
    id="candidatura"
    className="py-16 md:py-24"
    testid="section-candidatura"
  >
    <div className="grid lg:grid-cols-5 gap-10 items-start">
      <motion.div {...fadeUp} className="lg:col-span-2">
        <Overline>Candidatura</Overline>
        <H2 highlight="para a vaga">Candidate-se</H2>
        <p className="mt-6 text-lg text-[#64748B] leading-relaxed">
          Envie seu currículo atualizado e informe no assunto do e-mail:
        </p>
        <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-[#F6F8FB] border border-[#E5EAF2] text-sm font-mono text-[#1F2937]">
          Vaga Enfermeiro Adm – EMQ
        </div>

        <a
          data-testid="candidatura-mailto"
          href={MAILTO_SIMPLE}
          className="mt-8 inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-gradient-to-r from-[#3532B3] to-[#3787F5] text-white font-semibold shadow-[0_12px_28px_rgba(53,50,179,0.28)] hover:-translate-y-0.5 transition-all duration-300"
        >
          <Mail size={18} strokeWidth={2.2} />
          Enviar currículo por e-mail
        </a>

        <div className="mt-6 p-4 rounded-2xl bg-[#F6F8FB] border border-[#E5EAF2]">
          <div className="text-xs uppercase tracking-[0.16em] font-bold text-[#64748B]">
            E-mail para envio
          </div>
          <a
            href={`mailto:${APPLY_EMAIL}`}
            className="mt-2 flex items-center gap-2 text-[#3532B3] font-semibold hover:underline"
          >
            <Mail size={16} />
            {APPLY_EMAIL}
          </a>
        </div>
      </motion.div>

      <div className="lg:col-span-3">
        <ApplicationForm />
      </div>
    </div>
  </Section>
);

export const JobFinalCTA = () => (
  <section className="relative py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <motion.div
        {...ctaReveal}
        className="relative overflow-hidden rounded-[2.5rem] p-10 md:p-16 lg:p-20 shadow-[0_30px_80px_rgba(53,50,179,0.35)]"
        style={{
          background:
            "linear-gradient(135deg, #3532B3 0%, #3787F5 55%, #12DDB5 100%)",
        }}
      >
        <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-40 -left-20 w-[400px] h-[400px] rounded-full bg-[#73F2B3]/30 blur-3xl" />

        <div className="relative grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3">
            <Overline invert>Vamos conversar</Overline>
            <H2 invert highlight="mais seguras na saúde suplementar">
              Sua experiência em Enfermagem pode apoiar decisões
            </H2>
            <p className="mt-5 text-white/85 text-lg leading-relaxed max-w-2xl">
              Se você tem perfil técnico, comunicação clara e interesse em
              atuar com análise, auditoria e entrevista qualificada, queremos
              conhecer você.
            </p>
          </div>
          <div className="lg:col-span-2 flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-end">
            <a
              data-testid="cta-final-mailto"
              href={MAILTO_SIMPLE}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-white text-[#3532B3] font-bold shadow-[0_12px_30px_rgba(0,0,0,0.18)] hover:-translate-y-0.5 transition-all duration-300"
            >
              <Send size={18} strokeWidth={2.2} />
              Enviar currículo agora
            </a>
            <span className="text-white/80 text-sm">{APPLY_EMAIL}</span>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
